import { render } from "./AllProducts.vue?vue&type=template&id=43d70506&scoped=true"
import script from "./AllProducts.vue?vue&type=script&lang=js"
export * from "./AllProducts.vue?vue&type=script&lang=js"

import "./AllProducts.vue?vue&type=style&index=0&id=43d70506&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d70506"]])

export default __exports__